import { StringUtils } from "$lib/stringUtils";
import { Customer } from "../Customer";

export function getCustomerInfo(customer: Customer): string {

    if( customer.customerType?.id > 1 ) {
        if( StringUtils.isNullOrEmpty(customer.companyName)) {
            return customer.phoneNumber1;
        } 
        else {
            return `${customer.companyName}`;
        }
    }
    else {
        if( StringUtils.isNullOrEmpty(customer.firstname) && StringUtils.isNullOrEmpty(customer.lastname) ) {
            return customer.phoneNumber1;
        }
        else {
            return `${customer.lastname} ${customer.firstname}`;
        }
    }

}